import React, { useState } from "react";
import WebDevelopment from "../components/WebDevelopment";
import GraphicDesign from "../components/GraphicsDesign";
import Photography from "../components/Photography";
import MobileApps from "../components/MobileApp";
import "./Projects.css";

const Projects = () => {
  const [activeService, setActiveService] = useState("web-development");

  const services = [
    { id: "web-development", label: "Web Development" },
    { id: "photography", label: "Photography" },
    { id: "mobile-apps", label: "Mobile App Development" },
    { id: "graphic-design", label: "Graphic Design" },
  ];

  return (
    <section id="projects" className="projects-page py-5">
      <div className="container">
        {/* Page Header */}
        <div className="projects-header text-center mb-5">
          <h1 className="projects-title fw-bold">Our Projects</h1>
          <p className="projects-subtitle">
            Explore our portfolio of creative work across different services
          </p>
        </div>

        {/* Toggle Buttons */}
        <div className="services-toggle text-center mb-5">
          <div className="toggle-buttons">
            {services.map((service) => (
              <button
                key={service.id}
                className={`toggle-btn ${
                  activeService === service.id ? "active" : ""
                }`}
                onClick={() => setActiveService(service.id)}
              >
                {service.label}
              </button>
            ))}
          </div>
        </div>

        {/* Active Service Content */}
        <div className="service-content">
          {activeService === "web-development" && <WebDevelopment />}
          {activeService === "photography" && <Photography />}
          {activeService === "mobile-apps" && <MobileApps />}
          {activeService === "graphic-design" && <GraphicDesign />}
        </div>
      </div>
    </section>
  );
};

export default Projects;
